// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__5X2M7","progress":"ProgressBar_progress__SL7FS","percentageText":"ProgressBar_percentageText__mXhat"};